import { Button, Typography } from "@material-ui/core";


function FormSectionHeader(props) {
  const { 
    title, buttonText, titleProps, onButtonClick
  } = props;

  return (
    <div style={{
      display: 'flex', 
      flexDirection: 'row', 
      justifyContent: 'space-between', 
      width: '100%'}}
    >
      <Typography variant='h5' {...titleProps}>{title}</Typography>
      {onButtonClick ?
        <Button onClick={onButtonClick}>{buttonText}</Button>
        :
        null
      }
    </div>
  )
}

FormSectionHeader.defaultProps = {
  buttonHidden: false
}

export default FormSectionHeader;